import LayoutUtils from 'src/utils/layout_utils';
import { updateAvailableHeadingMeta } from './edit_form_time_section_heading';

/**
 * Set the active day in the available-slots UI and update heading.
 */
export function setActiveDay(section, headingTitle, dayKey) {
  section.querySelectorAll('.js-showing-view-time-day-toggle').forEach((toggle) => {
    const active = toggle.dataset.dayKey === dayKey;
    toggle.classList.toggle('showing-view-time__date-item--active', active);
    toggle.classList.toggle('js-showing-view-time-day-toggle--active', active);
  });

  section.querySelectorAll('.js-showing-view-time-day-panel').forEach((panel) => {
    LayoutUtils.toggle(panel, panel.dataset.dayKey === dayKey);
  });

  updateAvailableHeadingMeta(section, headingTitle, dayKey);
}

/**
 * Bind day toggles and time slots for the available-slots section.
 * callbacks: { updateSubmitInfo }
 */
export function initAvailableSlots(section, elements, callbacks = {}) {
  const { headingTitle, selectedInput, lockboxShowtimeInput } = elements;
  const { updateSubmitInfo } = callbacks;

  section.querySelectorAll('.js-showing-view-time-day-toggle').forEach((toggle) => {
    if (toggle.dataset.bound === 'true') return;
    toggle.dataset.bound = 'true';
    toggle.addEventListener('click', () => {
      setActiveDay(section, headingTitle, toggle.dataset.dayKey);
    });
  });

  section.querySelectorAll('.js-showing-view-time-slot').forEach((slot) => {
    if (slot.dataset.bound === 'true') return;
    slot.dataset.bound = 'true';
    slot.addEventListener('click', () => {
      section.querySelectorAll('.js-showing-view-time-slot').forEach((s) => {
        s.classList.remove('showing-view-time__slot--selected', 'js-showing-view-time-slot--selected');
      });
      slot.classList.add('showing-view-time__slot--selected', 'js-showing-view-time-slot--selected');
      if (selectedInput) {
        selectedInput.value = slot.dataset.value || '';
      }
      if (lockboxShowtimeInput) {
        lockboxShowtimeInput.value = '';
      }
      if (slot.dataset.dayKey) {
        setActiveDay(section, headingTitle, slot.dataset.dayKey);
      }
      updateSubmitInfo?.();
    });
  });
}
